import { loyaltyConstants } from "./types";
import { addMember, getReferences } from "../../../services/loyalty.service";
import { alertActions, loading } from "../alert/actions";
import { beginLogout } from "../login/actions";

const endError = (error) => {
  return (dispatch) => {
    dispatch(loading.hideLoading());
    if (error?.response?.status === 401 || error?.message === "Network Error") {
      dispatch(beginLogout());
    } else {
      dispatch(alertActions.error(error));
      dispatch({
        type: loyaltyConstants.LOYALTY_ERROR,
        error,
      });
    }
  };
};

const addMembers = (name, surName, phone, text, kvkkIzni, kvkkMetni) => {
  return (dispatch) => {
    dispatch(request({ name }));
    dispatch(loading.showLoading());
    addMember(name, surName, phone, text, kvkkIzni, kvkkMetni).then(
      (loyalty) => {
        dispatch(success(loyalty));
        dispatch(loading.hideLoading());
      },
      (error) => {
        dispatch(endError(error));
      }
    );
  };
  function request(loyalty) {
    return { type: loyaltyConstants.ADD_MEMBER_REQUEST, payload: { loyalty } };
  }
  function success(loyalty) {
    return { type: loyaltyConstants.ADD_MEMBER_SUCCESS, payload: { loyalty } };
  }
};

const getReferenceList = () => {
  return (dispatch) => {
    dispatch(request());
    dispatch(loading.showLoading());
    getReferences().then(
      (response) => {
        dispatch(success(response.data));
        dispatch(loading.hideLoading());
      },
      (error) => {
        dispatch(endError(error));
      }
    );
  };
  function request() {
    return {
      type: loyaltyConstants.REFERENCES_LIST_REQUEST,
      payload: {},
    };
  }
  function success(data) {
    return {
      type: loyaltyConstants.REFERENCES_LIST_SUCCESS,
      payload: { references: data },
    };
  }
};

const clearSuccessMessageLoyalty = () => {
  return {
    type: loyaltyConstants.CLEAR_SUCCESS_MESSAGE,
    payload: {},
  };
};

export { addMembers, getReferenceList, clearSuccessMessageLoyalty };
